import { render, staticRenderFns } from "./windowRate.vue?vue&type=template&id=153064b6"
import script from "./windowRate.vue?vue&type=script&lang=js"
export * from "./windowRate.vue?vue&type=script&lang=js"
import style0 from "./windowRate.vue?vue&type=style&index=0&id=153064b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports